// Wie mag de CARO-tab "Stemmen (platform)" zien (specs/20261020-spraakmeldingen-elevenlabs
// fase 1, VT-3 = A).
//
// TWEE voorwaarden, allebei nodig:
//   1. company 1 (CARO). `voice_profiles.manage_platform` is bewust NIET PROTECTED (CARO-only =
//      company-1-gate, V-23), dus een company_admin van ELKE klant houdt hem via
//      FULL_ACCESS_ROLES. Zonder deze controle zag die de pagina.
//   2. de sleutel zelf (aan geen enkele rol standaard toegekend).
//
// Eén bron voor de route (index.jsx), het menu (Layout.js) en de tests. De API herhaalt beide
// controles (requireCaroCompany + checkPermission); dit is geen toegangscontrole op zich.

export const VOICE_PLATFORM_KEY = 'voice_profiles.manage_platform';
export const CARO_COMPANY_ID = 1;

export function companyIdOf(user) {
  return Number(user?.company?.id ?? user?.companyId ?? user?.company_id);
}

export function canManagePlatformVoices({ user, hasPermission }) {
  if (!user || typeof hasPermission !== 'function') return false;
  return companyIdOf(user) === CARO_COMPANY_ID && !!hasPermission(VOICE_PLATFORM_KEY);
}

// ── Fase 2 (T103, V-23): de tenanttabs Teksten en Stemmen ─────────────────────────────────
//
// `voice_prompts.view` en `.manage` zijn PROTECTED: PermissionContext.hasPermission geeft ze aan
// een company_admin (of admin) pas na een expliciete toekenning. Geen company-1-voorwaarde: elke
// tenant ziet zijn eigen teksten; de API scopet op de tenant (404 daarbuiten).
export const VOICE_VIEW_KEY = 'voice_prompts.view';
export const VOICE_MANAGE_KEY = 'voice_prompts.manage';

export function canViewTenantVoice({ user, hasPermission }) {
  if (!user || typeof hasPermission !== 'function') return false;
  return !!hasPermission(VOICE_VIEW_KEY);
}

/** Bewerken vraagt beide: wie niet mag zien, mag ook niet bewerken. */
export function canManageTenantVoice({ user, hasPermission }) {
  return canViewTenantVoice({ user, hasPermission }) && !!hasPermission(VOICE_MANAGE_KEY);
}

/** Pagina en menu: één van beide sporen volstaat. */
export function canOpenVoicePage(args) {
  return canViewTenantVoice(args) || canManagePlatformVoices(args);
}

// ── T121h / T121i (eigenaar 2026-10-26) ───────────────────────────────────────────────────

/**
 * De bedrijfskiezer (organisatie kiezen) op de tabs Teksten en Stemmen: alleen company 1 (CARO)
 * EN rol `admin`. De API eert `?companyId` uitsluitend voor CROSS_ORG_ROLES (admin/super_admin,
 * utils/tenantScope.js); voor elke andere gebruiker zou een vreemde company 404 geven — dan tonen
 * we de kiezer ook niet. Klanten zien hem nooit.
 */
export function canPickVoiceCompany({ user }) {
  if (!user) return false;
  return companyIdOf(user) === CARO_COMPANY_ID && user.role === 'admin';
}

/** Platformteksten (scope 'platform') bewerken: dezelfde regel als de platformtab. */
export function canEditPlatformTexts({ user, hasPermission }) {
  return canManagePlatformVoices({ user, hasPermission });
}
